import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MobileBottomNav from '../Navigation/MobileBottomNav';
import './Layout.css';

function Layout({ children, hideHeader, hideFooter, hideMobileNav }) {
  const classNames = [
    'appMain',
    hideHeader ? 'appMainNoHeader' : '',
    hideMobileNav ? 'appMainNoMobileNav' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      {!hideHeader && <Header />}
      <main className={classNames}>
        {children}
        {!hideFooter && <Footer />}
      </main>
      {!hideHeader && !hideMobileNav && <MobileBottomNav />}
    </>
  );
}

export default Layout;
